import React, { useState } from "react"


import useForm from "../../../hooks/form-hook"
import UsersForm from "./UsersForm"
import fetchMSSQLHook from "../../../hooks/fetchMSSQL-hook"
import { useEffect } from "react"
import { NotificationManager } from "react-notifications"

const UsersTable = ({
  filter,
  data,
  setData,
  children,
  IsActive,
  id,
  page,
  sortRows,
  roles,
  warehouses,
}) => {
  const { form, openForm, closeForm } = useForm();
  const { fetchMssqlApi } = fetchMSSQLHook();
  const [samePassword, setSamePasword] = useState({ status: false, message: "" });
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  useEffect(() => {
    setSamePasword({ status: false, message: "" });
  }, [form]);

  const handleSubmit = (evt, locations) => {
    evt.preventDefault();

    const { name, role, warehouse, email, newPassword, newPasswordRepeat, userId, isActive } = evt.target.elements;
    const user = data.filter((user) => Number(user.UserId) === Number(userId.value))[0];
    const roleId =
      roles.filter((odjRole) => odjRole.Name === role.value)[0]?.RoleId ||
      roles.filter((odjRole) => odjRole.Name === user.Role)[0].RoleId;


    
    const warehouseId =
      warehouses.filter((wh) => wh.Name === warehouse.value)[0]?.WarehouseId ||
      warehouses.filter((wh) => wh.Name === user.WarehousName)[0].WarehouseId;

      if (newPassword.value !== newPasswordRepeat.value) {
      newPassword.value = "";
      newPasswordRepeat.value = "";
      return setSamePasword({ status: true, message: "Niepoprawno powtórzone hasło" });
    }
    
    if (!name.value) {
      NotificationManager.error("Wpisz imię użytkownika");
      name.focus();
      return;
    }
    
    let emailArr = [];
    data.filter((data) => data.Email !== user.Email).forEach((user) => emailArr.push(user.Email));
    if (emailArr.includes(email.value))
      return setSamePasword({ status: true, message: "Taki mail już istnieję" });

    if (String(newPassword.length) < 6)
      return setSamePasword({
        status: true,
        message: "Wpisz hasło dłuższe niż 6 znaków",
      });

    if (newPassword.value === newPasswordRepeat.value && samePassword.status)
      setSamePasword({ status: false, message: "" });

    const locationsToAdding = new Array();
    const locationsToDelete = new Array();

    for (let location of locations) {
      if (location.IsDeleted) locationsToDelete.push(location.LocationId);
      if (location.IsNew) locationsToAdding.push(location.LocationId);
    }

    const isActiveValue = isActive ? isActive.value === "1" : !!user.IsActive;

    const payload = {
      userName: name.value,
      roleId: roleId,
      warehouseId: warehouseId,
      email: email.value,
      newPassword: newPassword.value,
      isActive: isActiveValue,
      locationsToAdding,
      locationsToDelete,
    };

    fetchMssqlApi(`users/${userId.value}`, { method: "POST", data: payload }, (res) => {
      closeForm();
      setData();
    });
  };

  const TABLE_COLS = [
    { header: "Nazwa", key: "Name" },
    { header: "Email", key: "Email" },
    { header: "Aktywny", key: "IsActive", isBool: true },
    { header: "Magazyn", key: "WarehousName" },
    { header: "Rola", key: "Role" },
  ];

  const rowsPerPage = filter?.rowsPerPage || 50;

  const sortedData = typeof sortRows === "function" ? [...data].sort(sortRows) : data;

  return (
    <>
    <div
      className="overflow-auto custom-scroll"
      style={{
      maxHeight: `${windowHeight - 280}px`,
      overflowY: 'auto',
    }}
    >
      <table className="table table-striped border" style={{ width: "100%" }}>
        <thead>
          <tr className="text-center headers-color pe-none">
            {TABLE_COLS.map((c) => (
              <th key={c.key} className={c.key === "IsActive" ? "text-center" : ""}>
                {c.header}
              </th>
            ))}
            <th></th>
          </tr>
        </thead>

        <tbody>
          {sortedData
            .map((miniData, idx) => (
              <tr key={idx} className="text-center">
                {TABLE_COLS.map((c) => (
                  <td key={c.key}>
                    <div className="btn btn-link font-size-inherit text-reset text-decoration-none p-1 align-middle">
                      {c.isBool ? (
                        <input
                          type="checkbox"
                          style={{ width: "15px", height: "15px", marginTop: "9px" }}
                          checked={!!miniData?.[c.key]}
                          onChange={() => {}}
                        />
                      ) : (
                        miniData?.[c.key] ?? ""
                      )}
                    </div>
                  </td>
                ))}

                <td className="d-flex justify-content-end border-0 mb-2">
                  <button className="btn btn-outline-primary btn-sm" onClick={openForm(miniData[id])}>
                    Edytuj
                  </button>
                </td>

                {children}
              </tr>
            ))}
        </tbody>
      </table>
      </div>
      {form && (
        <UsersForm
          form={form}
          data={data}
          miniData={data.filter((data) => data.UserId == form)[0]}
          handleClose={closeForm}
          handleSubmit={handleSubmit}
          warning={samePassword}
        />
      )}
    </>
  );
};

export default UsersTable;
